<script>
export default {
	props: {
		logo: Object,
		logoAlt: Object,
	},
}
</script>

<template>
	<SafeLink to="/">
		<Media class="appbar--transparent__logo" :src="$b({ td: logo })" />
		<Media v-if="logoAlt" class="appbar--transparent__logo-alt" :src="$b({ td: logoAlt })" />
	</SafeLink>
</template>

